import type { ReactNode } from 'react';
import type { PublicSettings } from '@avh/shared';
import { SettingsContext } from '@/contexts/Settings';
import { useApi } from '@/lib/useApi';

export function SettingsProvider({ children }: { children: ReactNode }) {
  const [state] = useApi<PublicSettings>('/public/settings');
  return <SettingsContext value={state.status === 'success' ? state.data : null}>{children}</SettingsContext>;
}
